import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { Dropdown } from 'primereact/dropdown';

// import SelecaoAmparoLegal from '../../components/SelecaoAmparoLegal'
import RotuloSeplag from "../../components/RotuloSeplag";
import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from "../../components/SelecaoAmparoLegal";
import ModalSeplag from "../../components/ModalSeplag";

import { bloquearCertidao, desbloquearCertidao } from "../../service/EventoCertidao/bloquearDesbloquearCertidao"
import { buscarPorCodigo } from "../../service/certidao";

import CertidaoView from './certidaoView'

const ModalBloqueioDesbloqueio = (props) => {

    const amparo = useSelecaoAmparoLegal()
    const [tipoEventoCertidao, setTipoEventoCertidao] = useState({ code: 'BLOQ', descricao: "Bloquear" })
    const [tipoAcao, setTipoAcao] = useState("");

    const listaTipoEventoCertidao = [{ code: 'BLOQ', descricao: "Bloquear" }, { code: 'DESBLOQ', descricao: "Desbloquear" }]
    const [certidao, setCertidao] = useState(null);
    const [titulo, setTitulo] = useState('');


    useEffect(() => {
        buscarPorCodigo(props.certidaoSelected.idenCertidao).then(res => {
            setCertidao(res)
            if (res.flagSituacao == "BLOQUEADA") {
                setTipoEventoCertidao({ code: 'DESBLOQ', descricao: "Desbloquear " })
                setTipoAcao("Desbloquear Certidão")
                setTitulo('Desbloquear')
            } else {
                setTipoEventoCertidao({ code: 'BLOQ', descricao: "Bloquear " })
                setTipoAcao("Bloquear Certidão")
                setTitulo("Bloquear")
            }
        })

    }, [])

    const handleSalvar = () => {
        let amparoLegalSelecionado = amparo.justificativasSelecionada
        let data = new Date()

        let jsonBody = {
            idenCertidao: certidao.idenCertidao,
            dataEventoCertidao: `${data.toLocaleDateString('pt-BR')}`,
            siglaTipoEventoCertidao: tipoEventoCertidao.code,
            listaAmparoLegalCertidao: amparoLegalSelecionado,
        }

        if (tipoEventoCertidao.code == "BLOQ") {
            bloquearCertidao(jsonBody).then(res => {
                window.$toast.current.show({ severity: 'success', summary: res.data });
                props.onSalvar && props.onSalvar()
                props.onFechar()
            })
        } else {
            desbloquearCertidao(jsonBody).then(res => {
                window.$toast.current.show({ severity: 'success', summary: res.data });
                props.onSalvar && props.onSalvar()
                props.onFechar()
            })
        }


    }

    const handleChangeTipoEvento = (e) => {
        setTipoEventoCertidao(e.value)
        setTipoAcao(`${e.value.descricao} Certidão`)
    }

    if (!certidao) {
        return <> </>
    }
    return (
        <ModalSeplag titulo={titulo} visible={props.visible} fechar={props.onFechar} funcAcao={handleSalvar} tamanho="70em" labelAcao={tipoAcao}>
            <CertidaoView certidao={certidao} />
            <div className="p-col-12" />
            <RotuloSeplag obrigatorio nome="Tipo Evento" cols="12 6">
                <Dropdown value={tipoEventoCertidao} dataKey={'code'} optionLabel={'descricao'} options={listaTipoEventoCertidao} onChange={handleChangeTipoEvento} disabled />
            </RotuloSeplag>
            <SelecaoAmparoLegalRender {...amparo} />
        </ModalSeplag>
    );

};

ModalBloqueioDesbloqueio.propTypes = {
    visible: PropTypes.bool.isRequired,
    certidaoSelected: PropTypes.object.isRequired,
    onFechar: PropTypes.func.isRequired,
    onSalvar: PropTypes.func,
};

export default ModalBloqueioDesbloqueio;